import React, { useState, useEffect } from 'react';
import { AdaptiveModal } from '../Common/AdaptiveModal';
import Button from '../Common/Button';
import './Bookmarks.css';

const CATEGORIES = [
  { value: 'character', label: 'Characters', color: '#3B82F6' },
  { value: 'plot', label: 'Plot', color: '#10B981' },
  { value: 'setting', label: 'Setting', color: '#8B5CF6' },
  { value: 'theme', label: 'Themes', color: '#F59E0B' }
];

function CreateSynthesis({ isOpen, onClose, onSave }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      // Reset form when modal closes
      setTitle('');
      setContent('');
      setCategory('');
      setIsSaving(false);
    }
  }, [isOpen]);

  const handleSave = async () => {
    if (!title.trim()) {
      alert('Please enter a title for this synthesis note');
      return;
    }

    if (!content.trim()) {
      alert('Please enter content for this synthesis note');
      return;
    }

    setIsSaving(true);
    try {
      await onSave(title.trim(), content.trim(), category || null);
      onClose();
    } catch (err) {
      alert('Failed to create synthesis note: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const footer = (
    <div className="modal-actions">
      <Button variant="secondary" onClick={onClose} disabled={isSaving}>
        Cancel
      </Button>
      <Button variant="primary" onClick={handleSave} loading={isSaving}>
        Create Synthesis
      </Button>
    </div>
  );

  return (
    <AdaptiveModal
      isOpen={isOpen}
      onClose={onClose}
      title="Create Synthesis Note"
      footer={footer}
    >
      <div className="synthesis-modal-form">
        <div className="form-group">
          <label htmlFor="synthesis-title">
            Title <span className="required">*</span>
          </label>
          <input
            id="synthesis-title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter a descriptive title"
            className="form-input"
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="synthesis-content">
            Content <span className="required">*</span>
          </label>
          <textarea
            id="synthesis-content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter your synthesis notes..."
            className="form-textarea"
            rows={8}
          />
        </div>

        <div className="form-group">
          <label htmlFor="synthesis-category">Category (optional)</label>
          <select
            id="synthesis-category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="form-select"
          >
            <option value="">None</option>
            {CATEGORIES.map(cat => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </AdaptiveModal>
  );
}

export default CreateSynthesis;
